import { mapValues } from '../util/fp';
var createMediaQueries = mapValues(function (mediaExpression) {
  var _ref = typeof mediaExpression === 'string' ? {} : {
      prefix: '(min-width: ',
      suffix: 'px)'
    },
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? '' : _ref$prefix,
    _ref$suffix = _ref.suffix,
    suffix = _ref$suffix === void 0 ? '' : _ref$suffix;
  var enhancedExpression = prefix + mediaExpression + suffix;
  return "@media " + enhancedExpression;
});
export { createMediaQueries };
export default createMediaQueries;